import React from 'react';
import BarChartPanel from '../BarChartPanel/BarChartPanel';
import PieChartPanel from '../PieChartPanel/PieChartPanel';
import {
  PointOptionsObject,
  DrilldownEventObject,
  SeriesClickEventObject,
  SeriesBarOptions,
  SeriesBubbleOptions,
  SeriesLineOptions,
} from 'highcharts';
import {
  ChartType,
  IAnalysChart,
} from '../../../../Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Queries/EkonomiskAnalysChartQuery/EkonomiskAnalysChartQuery';
import BubbleChartPanel from '../BubbleChartPanel/BubbleChartPanel';
import LineChartPanel from '../LineChartPanel/LineChartPanel';

interface IProps {
  type: ChartType;
  title: string;
  link?: string;
  analys: IAnalysChart;
  onDrilldown: (event: DrilldownEventObject | SeriesClickEventObject) => void;
}

class GraphCard extends React.PureComponent<IProps> {
  getPanel = () => {
    switch (this.props.type) {
      case 'column':
        return (
          <BarChartPanel
            title={this.props.title}
            link={this.props.link}
            yAxisLabel="Värde - kr"
            categories={this.props.analys.categories}
            series={this.props.analys.series as unknown as SeriesBarOptions[]}
            drilldownEvent={this.props.onDrilldown}
          />
        );
      case 'pie':
        return (
          <PieChartPanel
            sign="cr"
            title={this.props.title}
            link={this.props.link}
            category={
              this.props.analys.series[0].data
                ? typeof (
                    this.props.analys.series[0].data[0] as PointOptionsObject
                  ).name === 'string'
                  ? ((this.props.analys.series[0].data[0] as PointOptionsObject)
                      .name as string)
                  : undefined
                : ''
            }
            data={this.props.analys.series.map(x => {
              const point: PointOptionsObject = {
                drilldown: x.data
                  ? (x.data[0] as PointOptionsObject).drilldown
                  : undefined,
                name: x.name,
                y: x.data ? (x.data[0] as PointOptionsObject).y : 0,
              };

              return point;
            })}
            drilldownEvent={this.props.onDrilldown}
          />
        );
      case 'bubble':
        return (
          <BubbleChartPanel
            title={this.props.title}
            link={this.props.link}
            yAxisLabel="Värde - kr"
            categories={this.props.analys.categories}
            series={
              this.props.analys.series as unknown as SeriesBubbleOptions[]
            }
            drilldownEvent={this.props.onDrilldown}
          />
        );
      case 'line':
        return (
          <LineChartPanel
            title={this.props.title}
            link={this.props.link}
            yAxisLabel="Värde - kr"
            categories={this.props.analys.categories}
            series={this.props.analys.series as unknown as SeriesLineOptions[]}
            drilldownEvent={this.props.onDrilldown}
          />
        );
    }
  };

  render() {
    return this.getPanel();
  }
}

export default GraphCard;
